export const COMMUNITY_MEMBERS = [
  {
    "name": "Anuj Bhasin",
    "title": "Strategic Advisor",
    "company": "internalforce.ai™",
    "location": "Gurgaon, India",
    "city": "Gurgaon",
    "country": "India",
    "headline": "",
    "skills": [
      "Consulting"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/anujbhasin2020",
    "initials": "AB",
    "color": "#4f46e5",
    "id": "m1",
    "founding": true
  },
  {
    "name": "Chirag Talwar",
    "title": "Head of Revenue Operations",
    "company": "GoAudits",
    "location": "India",
    "city": "",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/chirag-talwar-337627b0",
    "initials": "CT",
    "color": "#0d9488",
    "id": "m2",
    "founding": true
  },
  {
    "name": "Ashish Tayal",
    "title": "Head of Revenue Operations",
    "company": "OLOID",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/ashish-tayal-96485530",
    "initials": "AT",
    "color": "#b45309",
    "id": "m3",
    "founding": true
  },
  {
    "name": "Sunit Surati",
    "title": "Head of Business Operations, India",
    "company": "Locusview",
    "location": "Ahmedabad, India",
    "city": "Ahmedabad",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Operations"
    ],
    "seniority": "manager",
    "linkedin": "https://www.linkedin.com/in/sunit-surati-68135032",
    "initials": "SS",
    "color": "#be123c",
    "id": "m4",
    "founding": true
  },
  {
    "name": "Vijay R",
    "title": "Head of Business Operations & Support Services",
    "company": "Positka",
    "location": "Chennai, India",
    "city": "Chennai",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/vijay-r-82399236",
    "initials": "VR",
    "color": "#7c3aed",
    "id": "m5",
    "founding": true
  },
  {
    "name": "Parag Jain",
    "title": "Director of Business Operations",
    "company": "PAR Technology",
    "location": "Jaipur, India",
    "city": "Jaipur",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/paragjain007",
    "initials": "PJ",
    "color": "#0369a1",
    "id": "m6",
    "founding": true
  },
  {
    "name": "Mahesh Ram",
    "title": "Senior Director - Global Sales & Channel Operations",
    "company": "Automation Anywhere",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/mahesh-ram-b07aa614",
    "initials": "MR",
    "color": "#15803d",
    "id": "m7",
    "founding": false
  },
  {
    "name": "Rahul Patil",
    "title": "Associate Director of Sales Operations",
    "company": "BugendaiTech",
    "location": "Pune, India",
    "city": "Pune",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/merahulpatil",
    "initials": "RP",
    "color": "#c2410c",
    "id": "m8",
    "founding": false
  },
  {
    "name": "Vinay Sutrave",
    "title": "Director Sales Operations",
    "company": "Intel Corporation",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/vinay-sutrave-517a918",
    "initials": "VS",
    "color": "#9333ea",
    "id": "m9",
    "founding": false
  },
  {
    "name": "Arindam Sengupta",
    "title": "Vice President - Sales Operations",
    "company": "One97 Communications Limited",
    "location": "Delhi, India",
    "city": "Delhi",
    "country": "India",
    "headline": "",
    "skills": [
      "Sales"
    ],
    "seniority": "vp",
    "linkedin": "https://www.linkedin.com/in/arindam-sengupta-859b019",
    "initials": "AS",
    "color": "#0891b2",
    "id": "m10",
    "founding": false
  },
  {
    "name": "Chaitanya Kakkar",
    "title": "Vice President - Business & International Expansion",
    "company": "SingleInterface",
    "location": "Gurgaon, India",
    "city": "Gurgaon",
    "country": "India",
    "headline": "",
    "skills": [
      "Business Development"
    ],
    "seniority": "vp",
    "linkedin": "https://www.linkedin.com/in/ck10",
    "initials": "CK",
    "color": "#4f46e5",
    "id": "m11",
    "founding": false
  },
  {
    "name": "Anirudh Syal",
    "title": "Building SingleInterface",
    "company": "SingleInterface",
    "location": "Gurugram, India",
    "city": "Gurugram",
    "country": "India",
    "headline": "",
    "skills": [
      "Engineering"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/anirudhsyal",
    "initials": "AS",
    "color": "#0d9488",
    "id": "m12",
    "founding": false
  },
  {
    "name": "R N Mishra",
    "title": "Director - India Business Operations ( Sales, Business Development & Alliance)",
    "company": "InfoMagnus",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Sales"
    ],
    "seniority": "owner",
    "linkedin": "https://www.linkedin.com/in/r-n-mishra-826b2612",
    "initials": "RM",
    "color": "#b45309",
    "id": "m13",
    "founding": false
  },
  {
    "name": "Rajesh Bhattad",
    "title": "Director of Sales Operations",
    "company": "Multiplier",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/therevopsguy",
    "initials": "RB",
    "color": "#be123c",
    "id": "m14",
    "founding": false
  },
  {
    "name": "Avinash H",
    "title": "",
    "company": "",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/avinashheston",
    "initials": "AH",
    "color": "#7c3aed",
    "id": "m15",
    "founding": false
  },
  {
    "name": "Jaime R Wolfe",
    "title": "Senior Director, Revenue Operations and Sales Enablement",
    "company": "Paladin",
    "location": "Atlanta Metropolitan Area, United States",
    "city": "Atlanta Metropolitan Area",
    "country": "United States",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/jaimerwolfe",
    "initials": "JW",
    "color": "#0369a1",
    "id": "m16",
    "founding": false
  },
  {
    "name": "Manish Keshri",
    "title": "Head of Sales Operations & Strategy",
    "company": "Classplus",
    "location": "Noida, India",
    "city": "Noida",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/manish-keshri-2a894a87",
    "initials": "MK",
    "color": "#15803d",
    "id": "m17",
    "founding": false
  },
  {
    "name": "Andy Hryciw",
    "title": "Senior Vice President of Sales",
    "company": "iHeartMedia",
    "location": "Maitland, United States",
    "city": "Maitland",
    "country": "United States",
    "headline": "",
    "skills": [
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/andy-hryciw-1bb460a",
    "initials": "AH",
    "color": "#c2410c",
    "id": "m18",
    "founding": false
  },
  {
    "name": "Jeeven Joseph",
    "title": "Global Head of Business Development - Finance & Operations Suite",
    "company": "Zoho",
    "location": "Chennai, India",
    "city": "Chennai",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Finance"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/jeevenjoseph",
    "initials": "JJ",
    "color": "#9333ea",
    "id": "m19",
    "founding": false
  },
  {
    "name": "Kiran Rao",
    "title": "Head of Sales Operations",
    "company": "epiplex.ai",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/kiran-rao-a5a6a276",
    "initials": "KR",
    "color": "#0891b2",
    "id": "m20",
    "founding": false
  },
  {
    "name": "Deepak Nanwani",
    "title": "Head of Revenue & Operations",
    "company": "Yuma Energy",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/deepak-nanwani-1565577",
    "initials": "DN",
    "color": "#4f46e5",
    "id": "m21",
    "founding": false
  },
  {
    "name": "Taylor Gloege",
    "title": "Director of Revenue Operations & Project Management Office",
    "company": "Spinnaker Support",
    "location": "Littleton, United States",
    "city": "Littleton",
    "country": "United States",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "intern",
    "linkedin": "https://www.linkedin.com/in/taylorgloege",
    "initials": "TG",
    "color": "#0d9488",
    "id": "m22",
    "founding": false
  },
  {
    "name": "Kashish S",
    "title": "Head of Sales Operations",
    "company": "Truecaller",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/kashish-revops",
    "initials": "KS",
    "color": "#b45309",
    "id": "m23",
    "founding": false
  },
  {
    "name": "Michelle Anh Nguyen",
    "title": "Head of Business Operations & Strategy",
    "company": "Shipday",
    "location": "San Francisco Bay Area, United States",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "headline": "",
    "skills": [
      "IT",
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/michelleanhnguyen",
    "initials": "MN",
    "color": "#be123c",
    "id": "m24",
    "founding": false
  },
  {
    "name": "Rajath KN",
    "title": "Director of Strategy & Revenue Operations",
    "company": "Mindtickle",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/rajath-kn-08902a39",
    "initials": "RK",
    "color": "#7c3aed",
    "id": "m25",
    "founding": false
  },
  {
    "name": "Sandeep Pawar",
    "title": "Head of Business Operations",
    "company": "FSS",
    "location": "Mumbai, India",
    "city": "Mumbai",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/sandeep-pawar-28190322",
    "initials": "SP",
    "color": "#0369a1",
    "id": "m26",
    "founding": false
  },
  {
    "name": "Liping Zhang",
    "title": "Head of Revenue Operations",
    "company": "Integral Development Corp.",
    "location": "San Francisco, United States",
    "city": "San Francisco",
    "country": "United States",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/zhangliping85",
    "initials": "LZ",
    "color": "#15803d",
    "id": "m27",
    "founding": false
  },
  {
    "name": "Suraj Kumar",
    "title": "Director of Sales & Strategy Operations",
    "company": "TestMu AI",
    "location": "Noida, India",
    "city": "Noida",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Operations",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/suraj-kumar-062125135",
    "initials": "SK",
    "color": "#c2410c",
    "id": "m28",
    "founding": false
  },
  {
    "name": "Chetan Borkar",
    "title": "Director Sales - GTM",
    "company": "ARCON",
    "location": "Pune District, India",
    "city": "Pune District",
    "country": "India",
    "headline": "",
    "skills": [
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/chetan-borkar-1888098",
    "initials": "CB",
    "color": "#9333ea",
    "id": "m29",
    "founding": false
  },
  {
    "name": "Gautham Murdeshwar",
    "title": "Head of Revenue Operations",
    "company": "PagarBook",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Marketing",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/gautham-murdeshwar-a134a2164",
    "initials": "GM",
    "color": "#0891b2",
    "id": "m30",
    "founding": false
  },
  {
    "name": "Jessica N",
    "title": "Manager Revenue Operations | Global Head, GTM, SalesOps & Marops",
    "company": "Skan AI",
    "location": "India",
    "city": "",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/jessica-nathan22",
    "initials": "JN",
    "color": "#4f46e5",
    "id": "m31",
    "founding": false
  },
  {
    "name": "Ankush Goyal",
    "title": "Head of Strategy and Sales Operations",
    "company": "Adobe",
    "location": "Gurgaon, India",
    "city": "Gurgaon",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Operations",
      "Sales"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/ankushgoyal1988",
    "initials": "AG",
    "color": "#0d9488",
    "id": "m32",
    "founding": false
  },
  {
    "name": "Veena Sajee",
    "title": "Director- Sales Strategy and Business Operations",
    "company": "Sabre Corporation",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/veenasajee",
    "initials": "VS",
    "color": "#b45309",
    "id": "m33",
    "founding": false
  },
  {
    "name": "Apoorva Sharma PMP",
    "title": "Vice President & Head of Operations",
    "company": "Xindus",
    "location": "North Delhi, India",
    "city": "North Delhi",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "vp",
    "linkedin": "https://www.linkedin.com/in/apoorva-sharma1984",
    "initials": "AP",
    "color": "#be123c",
    "id": "m34",
    "founding": false
  },
  {
    "name": "Deepak PG",
    "title": "Senior Director Sales Operations",
    "company": "MetricStream",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "senior",
    "linkedin": "https://www.linkedin.com/in/deepakpg",
    "initials": "DP",
    "color": "#7c3aed",
    "id": "m35",
    "founding": false
  },
  {
    "name": "Sandeep Vishwanath C",
    "title": "Asst. Director Sales Operations",
    "company": "RMS",
    "location": "Pune, India",
    "city": "Pune",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/sandeepvishwanathc",
    "initials": "SC",
    "color": "#0369a1",
    "id": "m36",
    "founding": false
  },
  {
    "name": "Kartik Iyer",
    "title": "Director of Business Operations",
    "company": "DXC Technology",
    "location": "Mumbai, India",
    "city": "Mumbai",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/kartik-iyer-45749412b",
    "initials": "KI",
    "color": "#15803d",
    "id": "m37",
    "founding": false
  },
  {
    "name": "Radhika Rawat",
    "title": "Head of Sales Operations",
    "company": "Openprovider",
    "location": "India",
    "city": "",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/radhika-rawat-6985431a7",
    "initials": "RR",
    "color": "#c2410c",
    "id": "m38",
    "founding": false
  },
  {
    "name": "Sauvik Sinhababu",
    "title": "Head of Business Operations",
    "company": "JSW One Platforms Ltd.",
    "location": "Mumbai, India",
    "city": "Mumbai",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations"
    ],
    "seniority": "head",
    "linkedin": "https://www.linkedin.com/in/sauvik-sinhababu-21b48754",
    "initials": "SS",
    "color": "#9333ea",
    "id": "m39",
    "founding": false
  },
  {
    "name": "Abhijit Hardikar",
    "title": "Associate Vice President (Global Sales Operations)",
    "company": "Quest Global",
    "location": "Bengaluru, India",
    "city": "Bengaluru",
    "country": "India",
    "headline": "",
    "skills": [
      "Operations",
      "Sales"
    ],
    "seniority": "vp",
    "linkedin": "https://www.linkedin.com/in/abhijit-hardikar-038a3b12",
    "initials": "AH",
    "color": "#0891b2",
    "id": "m40",
    "founding": false
  },
  {
    "name": "Nick Watkins",
    "title": "Director of Commercial Operations",
    "company": "Voadera",
    "location": "United States",
    "city": "",
    "country": "United States",
    "headline": "",
    "skills": [
      "Operations",
      "Marketing",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/nick-watkins-profile",
    "initials": "NW",
    "color": "#4f46e5",
    "id": "m41",
    "founding": false
  },
  {
    "name": "Jai Anand",
    "title": "Director Sales Operations & Data Management",
    "company": "ConnectAndSell, Inc",
    "location": "Gurgaon, India",
    "city": "Gurgaon",
    "country": "India",
    "headline": "",
    "skills": [
      "IT",
      "Operations",
      "Sales"
    ],
    "seniority": "director",
    "linkedin": "https://www.linkedin.com/in/jai-anand",
    "initials": "JA",
    "color": "#0d9488",
    "id": "m42",
    "founding": false
  }
];

export const COMMUNITY_STATS = {"members": 42, "waitlist": 380, "applied_this_week": 41, "countries": 6};
